__turbopack_context__.v({
  "content": "styles-module-scss-module__hNbPvq__content",
  "icons": "styles-module-scss-module__hNbPvq__icons",
  "images": "styles-module-scss-module__hNbPvq__images",
  "images__item": "styles-module-scss-module__hNbPvq__images__item",
  "images__m": "styles-module-scss-module__hNbPvq__images__m",
  "images__phone": "styles-module-scss-module__hNbPvq__images__phone",
  "images__s": "styles-module-scss-module__hNbPvq__images__s",
  "inner": "styles-module-scss-module__hNbPvq__inner",
  "text": "styles-module-scss-module__hNbPvq__text",
  "text__buttons": "styles-module-scss-module__hNbPvq__text__buttons",
  "text__description": "styles-module-scss-module__hNbPvq__text__description",
  "text__title": "styles-module-scss-module__hNbPvq__text__title",
  "wrapper": "styles-module-scss-module__hNbPvq__wrapper",
});
